import Tasks from '@/pages/Tasks/Tasks.vue'

export default [
	{
		name: 'tasks',
		path: '/tasks',
		component: Tasks,
		meta: {
			secure: true
		}
	},
]